import { Buffer } from 'buffer';
import './styles.css';

// Stellar's browser-compatible XDR implementation expects Buffer to exist.
globalThis.Buffer = Buffer;
void import('./bootstrap');
